import React, { useState } from "react";
const navItems = [
  ["▦", "Dashboard"],
  ["▤", "Command Center"],
  ["✓", "Reports"],
  ["◈", "Campaign List"],
  ["⌂", "Jobs Map"],
  // ["♧", "Dealers"],
  // ["◫", "Distributors"],
  // ["◎", "Reports & MIS"],
];

const queue = [
  ["KMH-260821", "Sharma Auto Agency", "Uttar Pradesh", "Hoarding", "20 × 10 ft", "Pending Approval", "pending", ["Review", "Approve"]],
  ["KMH-260820", "Jai Ambey Traders", "Rajasthan", "Wall Painting", "18 × 8 ft", "Pending Approval", "pending", ["Review", "Approve"]],
  ["KMH-260817", "Balaji Motors", "Maharashtra", "Hoarding", "15 × 8 ft", "Design Review", "design", ["Open"]],
  ["KMH-260811", "Shiv Shakti Dealer", "Gujarat", "Wall Painting", "22 × 10 ft", "Approved", "approved", ["Track"]],
];

function BarRow({ label, width, value, tone }) {
  return (
    <div className="bar-row">
      <span>{label}</span>
      <div className="bar-track">
        <div className={`bar-fill ${tone}`} style={{ width }} />
      </div>
      <strong>{value}</strong>
    </div>
  );
}

function KamdhenuDashboard() {
  const [activeNav, setActiveNav] = useState("Dashboard");

  return (
    <>
      <style>{`
      :root{
  --kh-blue:#2f6fed;--kh-blue-dark:#183b78;--kh-blue-2:#eaf1ff;--kh-red:#d71920;
  --kh-yellow:#f6c744;--kh-green:#1f9d63;--kh-orange:#f08c28;--kh-ink:#182230;
  --kh-muted:#6b7685;--kh-line:#e5eaf0;--kh-bg:#f5f7fb;
}
  *{box-sizing:border-box}html,body,#root{margin:0;min-height:100%;width:100%}button,input,select{font:inherit}body{background:#f5f7fb}img{max-width:100%}
.kh-dashboard{min-height:100vh;background:var(--kh-bg);color:var(--kh-ink);font-family:Inter,system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;display:flex}
.kh-sidebar{width:235px;background:#0f2147;color:#fff;display:flex;flex-direction:column;min-height:100vh;position:sticky;top:0}
.kh-brand{display:flex;gap:10px;align-items:center;padding:18px 15px 14px;border-bottom:1px solid rgba(255,255,255,.1)}
.kh-brand img{width:51px;height:37px;border-radius:9px;object-fit:cover;}
.kh-brand strong{display:block;font-size:15px}.kh-brand span{display:block;color:#aebbd3;font-size:9px;margin-top:2px}
.kh-company{padding:14px 15px;border-bottom:1px solid rgba(255,255,255,.1)}
.kh-company-label{font-size:9px;color:#94a5c4;text-transform:uppercase;letter-spacing:.08em;margin-bottom:7px}
.kh-company img{width:145px;height:38px;object-fit:contain;background:#fff;border-radius:6px;padding:4px}
.kh-nav{padding:12px 9px;display:flex;flex-direction:column;gap:3px}
.kh-nav button{border:0;background:transparent;color:#c5d0e3;text-align:left;padding:11px 12px;border-radius:8px;font-size:11px;font-weight:700;cursor:pointer}
.kh-nav button:hover,.kh-nav button.active{background:#2454a4;color:#fff}
.kh-nav .ico{display:inline-block;width:24px;font-size:15px;text-align:center;margin-right:7px}
.kh-sidebar-footer{margin-top:auto;padding:13px 15px;color:#8191ad;font-size:9px;border-top:1px solid rgba(255,255,255,.08)}
.kh-main{flex:1;min-width:0}.kh-topbar{height:70px;background:#fff;border-bottom:1px solid var(--kh-line);display:flex;align-items:center;justify-content:space-between;padding:0 24px;gap:15px}
.kh-topbar h1{font-size:18px;margin:0}.crumb{font-size:10px;color:var(--kh-muted);margin-top:3px}
.kh-actions{display:flex;align-items:center;gap:8px}.kh-select,.filter{border:1px solid #d6dde7;border-radius:7px;background:#fff;padding:9px 10px;font-size:11px;color:#3b4657}
.kh-icon-btn{border:1px solid #d6dde7;background:#fff;border-radius:7px;width:36px;height:36px;cursor:pointer}
.kh-user{display:flex;align-items:center;gap:8px;margin-left:3px}.kh-avatar{width:34px;height:34px;border-radius:50%;display:grid;place-items:center;background:#eaf1ff;color:var(--kh-blue);font-size:11px;font-weight:900}.kh-user strong{display:block;font-size:10px}.kh-user small{display:block;color:var(--kh-muted);font-size:9px;margin-top:2px}
.kh-content{padding:17px 20px 28px}.kh-hero{background:linear-gradient(100deg,#17499d,#2f6fed);color:#fff;border-radius:11px;padding:20px 21px;display:flex;justify-content:space-between;gap:20px;align-items:center;box-shadow:0 8px 24px rgba(38,89,170,.14)}
.kh-hero h2{font-size:20px;margin:0 0 5px}.kh-hero p{margin:0;color:#dbe7ff;font-size:11px}.kh-hero-meta{display:flex;gap:8px}.hero-pill{background:rgba(255,255,255,.12);border:1px solid rgba(255,255,255,.15);border-radius:9px;padding:9px 13px;min-width:105px}.hero-pill strong{display:block;font-size:18px}.hero-pill span{font-size:8px;color:#dbe7ff}
.kh-kpis{display:grid;grid-template-columns:repeat(5,1fr);gap:12px;margin-top:14px}.kh-card{background:#fff;border:1px solid var(--kh-line);border-radius:10px;box-shadow:0 2px 10px rgba(32,55,88,.04)}.kh-kpi{padding:14px;border-top:3px solid var(--kh-blue)}.kh-kpi.red{border-top-color:var(--kh-red)}.kh-kpi.yellow{border-top-color:var(--kh-yellow)}.kh-kpi.blue{border-top-color:var(--kh-blue)}.kh-kpi.orange{border-top-color:var(--kh-orange)}.kh-kpi.green{border-top-color:var(--kh-green)}.tag{font-size:9px;color:var(--kh-muted);font-weight:800}.value{font-size:25px;font-weight:900;margin-top:4px}.delta{font-size:9px;color:var(--kh-green);margin-top:3px}.kh-kpi.yellow .delta{color:#936d00}.kh-kpi.orange .delta{color:#b8640f}
.kh-grid2{display:grid;grid-template-columns:1.3fr 1fr;gap:14px;margin-top:14px}.kh-grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:14px;margin-top:14px}.kh-panel{padding:15px}.panel-head{display:flex;justify-content:space-between;align-items:flex-start;gap:10px}.panel-title{font-weight:900;font-size:12px}.panel-sub{font-size:9px;color:var(--kh-muted);margin-top:3px}.badge-live{background:#eaf7f0;color:#178152;border-radius:99px;padding:5px 8px;font-size:8px;font-weight:900}.link{font-size:9px;color:var(--kh-blue);font-weight:800;cursor:pointer}
.chart{height:180px;display:flex;align-items:flex-end;justify-content:space-around;gap:10px;padding:18px 10px 4px;border-bottom:1px solid #eef1f5;margin-top:5px;background:repeating-linear-gradient(to bottom,transparent 0,transparent 44px,#eef1f5 45px)}
.bar{height:100%;display:flex;flex-direction:column;justify-content:flex-end;align-items:center;gap:7px;flex:1}.col{width:36px;max-width:70%;border-radius:5px 5px 0 0}.blue-bg{background:var(--kh-blue)}.red-bg{background:var(--kh-red)}.yellow-bg{background:var(--kh-yellow)}.green-bg{background:var(--kh-green)}.orange-bg{background:var(--kh-orange)}.bar span{font-size:9px;color:var(--kh-muted)}
.kh-legend{display:flex;gap:15px;margin-top:8px;font-size:9px;color:var(--kh-muted)}.kh-legend i{display:inline-block;width:8px;height:8px;border-radius:50%;margin-right:5px}.legend-blue{background:var(--kh-blue)}.legend-red{background:var(--kh-red)}.section-note{background:#f7f9fc;border-radius:7px;padding:8px;font-size:9px;color:#68758a;margin-top:9px}
.donut-wrap{display:flex;align-items:center;gap:22px;padding:20px 8px 10px}.donut{width:150px;height:150px;border-radius:50%;background:conic-gradient(var(--kh-red) 0 36%,var(--kh-blue) 36% 60%,var(--kh-yellow) 60% 76%,var(--kh-green) 76% 91%,#d7dde5 91% 100%);display:grid;place-items:center;flex:none}.donut:before{content:"";position:absolute;width:92px;height:92px;border-radius:50%;background:#fff}.donut-center{position:relative;font-size:22px;font-weight:900}.legend-list{font-size:9px;display:grid;gap:11px}.legend-item{display:flex;align-items:center;gap:7px}.dot{width:9px;height:9px;border-radius:50%;display:inline-block}.dot-red{background:var(--kh-red)}.dot-blue{background:var(--kh-blue)}.dot-yellow{background:var(--kh-yellow)}.dot-green{background:var(--kh-green)}.dot-grey{background:#d7dde5}
.bar-list{margin-top:17px;display:grid;gap:13px}.bar-row{display:grid;grid-template-columns:105px 1fr 27px;align-items:center;gap:7px;font-size:9px}.bar-track{height:7px;background:#edf1f5;border-radius:99px;overflow:hidden}.bar-fill{height:100%;border-radius:99px}
.queue-panel{margin-top:14px}.filter-row{display:flex;gap:7px;margin:13px 0}.filter{padding:8px 9px;flex:0 0 auto}.filter-row input{min-width:170px;flex:1}.table-scroll{overflow:auto}.tbl{width:100%;border-collapse:collapse;font-size:9px;min-width:760px}.tbl th{background:#f7f9fb;color:#718096;text-transform:uppercase;font-size:8px;text-align:left;padding:9px}.tbl td{border-top:1px solid #edf0f4;padding:10px 9px;white-space:nowrap}.status{padding:4px 7px;border-radius:99px;font-size:8px;font-weight:800}.status.pending{background:#fff5d9;color:#936d00}.status.design{background:#fff0df;color:#b8640f}.status.approved{background:#e9f8f0;color:#177c50}.row-actions{display:flex;gap:5px}.mini{border:1px solid #d7dee8;background:#fff;border-radius:5px;padding:5px 7px;font-size:8px;cursor:pointer}.mini:hover{background:#f3f6fa}
.quick{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-top:14px}.quick-btn{background:#fff;border:1px solid var(--kh-line);border-radius:9px;text-align:left;padding:13px;cursor:pointer}.quick-btn:hover{border-color:#b9c9e6}.quick-btn strong{display:block;font-size:10px}.quick-btn span{display:block;font-size:8px;color:var(--kh-muted);margin-top:3px}
@media(max-width:1100px){.kh-sidebar{width:210px}.kh-kpis{grid-template-columns:repeat(3,1fr)}.kh-grid3{grid-template-columns:1fr}.kh-hero{align-items:flex-start;flex-direction:column}.kh-hero-meta{width:100%}.hero-pill{flex:1}.kh-actions .kh-select:nth-child(2){display:none}}
@media(max-width:760px){.kh-dashboard{display:block}.kh-sidebar{position:relative;width:100%;min-height:auto}.kh-company,.kh-sidebar-footer{display:none}.kh-nav{display:grid;grid-template-columns:repeat(4,1fr)}.kh-nav button{padding:9px 5px;text-align:center;font-size:8px}.kh-nav .ico{display:block;width:auto;margin:0 0 3px}.kh-topbar{height:auto;padding:12px;align-items:flex-start}.kh-topbar h1{font-size:15px}.kh-actions{flex-wrap:wrap;justify-content:flex-end}.kh-user{display:none}.kh-content{padding:12px}.kh-kpis,.kh-grid2{grid-template-columns:1fr}.kh-grid3{grid-template-columns:1fr}.quick{grid-template-columns:1fr}.kh-hero-meta{overflow:auto}.hero-pill{min-width:105px}.donut-wrap{justify-content:center}.filter-row{overflow:auto}.kh-brand{padding:10px 12px}}


      `}
      </style>

    <div className="kh-dashboard">
      <aside className="kh-sidebar">
        <div className="kh-brand">
          <img
            src="assets/img/snap4me_logo_circle.png"
            alt="SNAP4ME"
          />
          <div>
            <strong>SNAP4ME</strong>
            <span>Marketing Activity Platform</span>
          </div>
        </div>

        <div className="kh-company">
          <div className="kh-company-label">Company Dashboard</div>
          <img
            src="assets/img/logo.webp"
            alt="Kamdhenu Group"
          />
        </div>

        <nav className="kh-nav">
          {navItems.map(([icon, label]) => (
            <button
              key={label}
              className={activeNav === label ? "active" : ""}
              onClick={() => setActiveNav(label)}
              type="button"
            >
              <span className="ico">{icon}</span>
              {label}
            </button>
          ))}
        </nav>

        <div className="kh-sidebar-footer">SNAP4ME • v1.0 Prototype</div>
      </aside>

      <main className="kh-main">
        <header className="kh-topbar">
          <div>
            <h1>Marketing Head Dashboard</h1>
            <div className="crumb">Kamdhenu Group / Marketing Activities</div>
          </div>

          <div className="kh-actions">
            <select className="kh-select" defaultValue="All India">
              <option>All India</option>
              <option>Uttar Pradesh</option>
              <option>Rajasthan</option>
              <option>Maharashtra</option>
            </select>
            <select className="kh-select" defaultValue="Aug 2026">
              <option>Aug 2026</option>
              <option>Jul 2026</option>
              <option>Jun 2026</option>
            </select>
            <button className="kh-icon-btn" type="button" aria-label="Notifications">🔔</button>
            <div className="kh-user">
              <div className="kh-avatar">MH</div>
              <div>
                <strong>Marketing Head</strong>
                <small>Head Office</small>
              </div>
            </div>
          </div>
        </header>

        <section className="kh-content">
          <div className="kh-hero">
            <div>
              <h2>Good morning, Marketing Head</h2>
              <p>Review pending requirements, design approvals and execution progress across India.</p>
            </div>
            <div className="kh-hero-meta">
              <div className="hero-pill"><strong>42</strong><span>Awaiting Approval</span></div>
              <div className="hero-pill"><strong>17</strong><span>Design Review</span></div>
              <div className="hero-pill"><strong>86%</strong><span>On-time Execution</span></div>
            </div>
          </div>

          <div className="kh-kpis">
            <div className="kh-card kh-kpi red"><div className="tag">New Requirements</div><div className="value">128</div><div className="delta">↑ 14% vs last month</div></div>
            <div className="kh-card kh-kpi yellow"><div className="tag">Pending Approval</div><div className="value">42</div><div className="delta">12 high priority</div></div>
            <div className="kh-card kh-kpi blue"><div className="tag">Approved Jobs</div><div className="value">286</div><div className="delta">+8% this month</div></div>
            <div className="kh-card kh-kpi orange"><div className="tag">Design Pending</div><div className="value">17</div><div className="delta">9 awaiting ASM</div></div>
            <div className="kh-card kh-kpi green"><div className="tag">Completed</div><div className="value">311</div><div className="delta">93% evidence received</div></div>
          </div>

          <div className="kh-grid2">
            <div className="kh-card kh-panel">
              <div className="panel-head">
                <div><div className="panel-title">Monthly Activity Trend</div><div className="panel-sub">Marketing jobs raised vs completed</div></div>
                <span className="badge-live">LIVE DATA</span>
              </div>
              <div className="chart">
                {[["Mar","blue-bg","49%"],["Apr","red-bg","62%"],["May","blue-bg","58%"],["Jun","red-bg","68%"],["Jul","blue-bg","74%"],["Aug","red-bg","84%"]].map(([m,c,h]) => (
                  <div className="bar" key={m}><div className={`col ${c}`} style={{ height: h }} /><span>{m}</span></div>
                ))}
              </div>
              <div className="kh-legend"><span><i className="legend-blue" />Completed</span><span><i className="legend-red" />Raised</span></div>
              <div className="section-note">Current month is tracking above the minimum planning estimate of 400 jobs.</div>
            </div>

            <div className="kh-card kh-panel">
              <div className="panel-head"><div><div className="panel-title">Activity Mix</div><div className="panel-sub">Current month</div></div><span className="link">View all</span></div>
              <div className="donut-wrap">
                <div className="donut"><div className="donut-center">400</div></div>
                <div className="legend-list">
                  <div className="legend-item"><span className="dot dot-red" />Hoarding — 36%</div>
                  <div className="legend-item"><span className="dot dot-blue" />Wall Painting — 24%</div>
                  <div className="legend-item"><span className="dot dot-yellow" />Dealer Board — 16%</div>
                  <div className="legend-item"><span className="dot dot-green" />Other — 15%</div>
                  <div className="legend-item"><span className="dot dot-grey" />Pending / Other — 9%</div>
                </div>
              </div>
            </div>
          </div>

          <div className="kh-grid3">
            <div className="kh-card kh-panel">
              <div className="panel-head"><div><div className="panel-title">State-wise Workload</div><div className="panel-sub">Open + approved jobs</div></div><span className="link">Full report</span></div>
              <div className="bar-list">
                <BarRow label="Uttar Pradesh" width="88%" value="92" tone="red-bg" />
                <BarRow label="Rajasthan" width="73%" value="76" tone="blue-bg" />
                <BarRow label="Maharashtra" width="58%" value="61" tone="yellow-bg" />
                <BarRow label="Madhya Pradesh" width="49%" value="51" tone="green-bg" />
                <BarRow label="Gujarat" width="42%" value="44" tone="orange-bg" />
              </div>
            </div>

            <div className="kh-card kh-panel">
              <div className="panel-head"><div><div className="panel-title">Approval Funnel</div><div className="panel-sub">This month</div></div><span className="link">Open approvals</span></div>
              <div className="bar-list">
                <BarRow label="Raised" width="100%" value="400" tone="red-bg" />
                <BarRow label="Distributor" width="91%" value="364" tone="blue-bg" />
                <BarRow label="HOD" width="84%" value="337" tone="yellow-bg" />
                <BarRow label="Marketing Head" width="72%" value="286" tone="green-bg" />
              </div>
            </div>

            <div className="kh-card kh-panel">
              <div className="panel-head"><div><div className="panel-title">Execution Health</div><div className="panel-sub">Approved jobs</div></div><span className="badge-live">86% ON-TIME</span></div>
              <div className="bar-list">
                <BarRow label="On-time" width="86%" value="246" tone="green-bg" />
                <BarRow label="In execution" width="41%" value="61" tone="blue-bg" />
                <BarRow label="Delayed" width="18%" value="24" tone="red-bg" />
                <BarRow label="Rejected design" width="8%" value="11" tone="orange-bg" />
              </div>
            </div>
          </div>

          <div className="kh-card kh-panel queue-panel">
            <div className="panel-head">
              <div><div className="panel-title">Marketing Head Approval Queue</div><div className="panel-sub">Review requirements and edit specification before approval</div></div>
              <span className="link">View all 42</span>
            </div>

            <div className="filter-row">
              <select className="filter" defaultValue="All States"><option>All States</option></select>
              <select className="filter" defaultValue="All Activity Types"><option>All Activity Types</option><option>Hoarding</option><option>Wall Painting</option></select>
              <select className="filter" defaultValue="All Priorities"><option>All Priorities</option><option>High</option><option>Normal</option></select>
              <input className="filter" placeholder="Search dealer / job ID" />
            </div>

            <div className="table-scroll">
              <table className="tbl">
                <thead><tr><th>Job ID</th><th>Dealer</th><th>State</th><th>Activity</th><th>Requested</th><th>Status</th><th>Action</th></tr></thead>
                <tbody>
                  {queue.map(([job, dealer, state, activity, requested, status, cls, actions]) => (
                    <tr key={job}>
                      <td><strong>{job}</strong></td><td>{dealer}</td><td>{state}</td><td>{activity}</td><td>{requested}</td>
                      <td><span className={`status ${cls}`}>{status}</span></td>
                      <td className="row-actions">{actions.map(a => <button className="mini" type="button" key={a}>{a}</button>)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="quick">
            <button className="quick-btn" type="button"><strong>＋ New Marketing Job</strong><span>Open request creation</span></button>
            <button className="quick-btn" type="button"><strong>✓ Approval Queue</strong><span>42 requests awaiting review</span></button>
            <button className="quick-btn" type="button"><strong>◎ MIS &amp; Reports</strong><span>Export state and vendor reports</span></button>
          </div>
        </section>
      </main>
    </div>
    </>
  );
}

export default KamdhenuDashboard;
